

export const fetchIndicatorsData = async (request, selectedIndicator, year) => {
  try {
    const params = new URLSearchParams();

    if (selectedIndicator) {
      params.append("indicator", selectedIndicator);
    }

    if (year) {
      params.append("year", year);
    }

    const query = params.toString();

    const response = await request(
      "GET",
      `/v1/survey/indicators${query ? `?${query}` : ""}`,
      {},
      "survey_service"
    );

    return response;
  } catch (error) {
    console.log(error);
  }
};


export const fetchDistrictBoundary = async (request) => {
  try {
    const response = await request(
      "GET",
      `/v1/survey/indicators/districts`,
      {},
      "survey_service"
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};


export const fetchYearsForIndicator = async (request, setYears) => {
  try {
    const response = await request("GET", "/v1/city-profile/distinct-years", {}, "survey_service");
    if (response?.length) {
      setYears(response);
    }
  } catch (error) {
    console.log(error);
  }
};
